import { yupResolver } from "@hookform/resolvers/yup";
import { Card, Button, Select, Label, TextInput, Checkbox, Textarea } from "flowbite-react";
import { useForm } from "react-hook-form";
import { settingsSchema } from "../schemas/settings.schema";
import useSettings from "../hooks/useSettings";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { TableResults } from "../components";

const SettingsScreen = () => {
    const { loading, error, settings, fetchSettings, saveSettings } = useSettings();

    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(settingsSchema),
      });

    const save = async (data: any) => {
        if(!data) return

        const response = await saveSettings(data)
        toast(response ? "Ajustes guardados correctamente" : "Ocurrió un error al guardar los ajustes.", {
            type: response ? "success" :"error"
        })
    }

    const initialize = () => {
        setValue("app_ads_per_news", settings?.app_ads_per_news || 0)
        setValue("facebook_url", settings?.facebook_url || "")
        setValue("instagram_url", settings?.instagram_url || "")
        setValue("tiktok_url", settings?.tiktok_url || "")
        setValue("twitter_url", settings?.twitter_url || "")
        setValue("youtube_url", settings?.youtube_url || "")
        setValue("video_streaming", settings?.video_streaming || "")
        setValue("video_streaming_active", settings?.video_streaming_active || false)
    }

    useEffect(() => {
        if(!settings) return
        initialize()
        // eslint-disable-next-line
    },[settings])

    useEffect(() => {
        (async () => {
            await fetchSettings()
        })()
        // eslint-disable-next-line
    },[])

    return <div className="m-4">
        <TableResults
            loading={loading}
            error={error?.toString()}
            itemsCount={settings ? Object.keys(settings).length : 0}
        >
            <>
            <div className="mb-4">
                <div className="flex flex-row justify-between">
                    <h1 className="text-xl font-semibold text-gray-900 sm:text-2xl dark:text-white">Ajustes</h1>
                    <Button isProcessing={loading} disabled={loading} onClick={handleSubmit(save)}>Guardar ajustes</Button>
                </div>
            </div>
            <Card>
                <div className="flex flex-col mb-2">
                    <Label className="mb-2">Facebook URL</Label>
                    <TextInput 
                        placeholder="Escriba aquí"
                        {...register("facebook_url")}
                        helperText={errors && errors.facebook_url ? errors.facebook_url.message : ""}
                        required 
                        color={errors && errors.facebook_url ? "failure" : "gray"}
                    />
                </div>
                <div className="flex flex-col mb-2">
                    <Label className="mb-2">Youtube URL</Label>
                    <TextInput 
                        placeholder="Escriba aquí"
                        {...register("youtube_url")}
                        helperText={errors && errors.youtube_url ? errors.youtube_url.message : ""}
                        required 
                        color={errors && errors.youtube_url ? "failure" : "gray"}
                    />
                </div>
                <div className="flex flex-col mb-2">
                    <Label className="mb-2">Tiktok URL</Label>
                    <TextInput 
                        placeholder="Escriba aquí"
                        {...register("tiktok_url")}
                        helperText={errors && errors.tiktok_url ? errors.tiktok_url.message : ""}
                        required 
                        color={errors && errors.tiktok_url ? "failure" : "gray"}
                    />
                </div>
                <div className="flex flex-col mb-2">
                    <Label className="mb-2">Instagram URL</Label>
                    <TextInput 
                        placeholder="Escriba aquí"
                        {...register("instagram_url")}
                        helperText={errors && errors.instagram_url ? errors.instagram_url.message : ""}
                        required 
                        color={errors && errors.instagram_url ? "failure" : "gray"}
                    />
                </div>
                <div className="flex flex-col mb-2">
                    <Label className="mb-2">X (Twitter) URL</Label>
                    <TextInput 
                        placeholder="Escriba aquí"
                        {...register("twitter_url")}
                        helperText={errors && errors.twitter_url ? errors.twitter_url.message : ""}
                        required 
                        color={errors && errors.twitter_url ? "failure" : "gray"}
                    />
                </div>
                <div className="flex flex-col mb-2">
                    <Label className="mb-2">Mostrar publicidad en la aplicación cada:</Label>
                    <Select
                        {...register("app_ads_per_news")}
                        helperText={errors && errors.app_ads_per_news ? errors.app_ads_per_news.message : ""}
                        required 
                        color={errors && errors.app_ads_per_news ? "failure" : "gray"}
                    >
                        <option value="-1">- Elija una opción -</option>
                        <option value="5">5 notas</option>
                        <option value="10">10 notas</option>
                        <option value="15">15 notas</option>
                    </Select>
                </div>
                <div className="flex flex-col mb-2">
                    <Label className="mb-2">Código de Video Streaming</Label>
                    <Textarea 
                        placeholder="Escriba aquí"
                        {...register("video_streaming")}
                        helperText={errors && errors.video_streaming ? errors.video_streaming.message : ""}
                        required 
                        color={errors && errors.video_streaming ? "failure" : "gray"}
                    />
                </div>
                <div className="flex flex-row-reverse mb-2 items-center justify-end">
                    <Label className="ml-2">¿Activar Video Streaming?</Label>
                    <Checkbox 
                        placeholder="Escriba aquí"
                        {...register("video_streaming_active")}
                        required 
                        color={errors && errors.video_streaming_active ? "failure" : "gray"}
                    />
                    {errors && errors.video_streaming_active && <p>{errors.video_streaming_active.message}</p>}
                </div>
            </Card>
            </>
        </TableResults>
    </div>
}


export default SettingsScreen